import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/api/auth/me')
      .then(d => setUser(d.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password, totp) {
    const { user } = await api('/api/auth/login', { method: 'POST', body: { email, password, totp } });
    setUser(user);
    return user;
  }
  async function logout() {
    await api('/api/auth/logout', { method: 'POST' });
    setUser(null);
  }
  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

const RANK = { OWNER: 4, ADMIN: 3, ACCOUNTANT: 2, VIEWER: 1 };
export const hasRole = (user, min) => user && RANK[user.role] >= RANK[min];
